import React, { Fragment } from "react";
import { CryptoData, CurrencyCountResponse } from "@/types/Currency.tsx";
import { useQuery } from "@tanstack/react-query";
import { ApiResponse } from "@/types/Api.tsx";
import GenericApi from "@/api/genericApi.tsx";
import { CryptoDataQueryKey } from "@/config/constants/QueryKeys.tsx";
import { isBitramp } from "@/utils/utils";

interface CryptoTileProps {
  currency: CurrencyCountResponse | null;
}

const CryptoTile: React.FC<CryptoTileProps> = ({ currency }) => {
  const url = `https://min-api.cryptocompare.com/data`;

  const { data: cryptoData } = useQuery<ApiResponse<CryptoData>>({
    queryFn: async () =>
      GenericApi.get<CryptoData>(
        `/pricemultifull?fsyms=${currency?.currency}&tsyms=${currency?.currency}`,
        url
      ),
    queryKey: [CryptoDataQueryKey, currency?.currency],
  });

  const getMediaLink = () => {
    if (currency?.currency) {
      return cryptoData?.data?.RAW?.[currency?.currency]?.[currency?.currency]
        ?.IMAGEURL;
    }

    return null;
  };

  const mediaLink = getMediaLink();

  const flagUrls: Record<string, string> = {
    EUR: "https://flagcdn.com/w320/eu.png",
    USD: "https://flagcdn.com/w320/us.png",
    RON: "https://flagcdn.com/w320/ro.png",
    GBP: "https://flagcdn.com/w320/gb.png",
    JPY: "https://flagcdn.com/w320/jp.png",
    PLN: "https://flagcdn.com/w320/pl.png",
    AUD: "https://flagcdn.com/w320/au.png",
    CAD: "https://flagcdn.com/w320/ca.png",
    CHF: "https://flagcdn.com/w320/ch.png",
    // Adaugă aici alte monede relevante
  };

  const imageUrl =
    (currency?.currency && flagUrls[currency.currency]) ||
    (mediaLink
      ? `https://www.cryptocompare.com/${mediaLink}`
      : "https://via.placeholder.com/24");

  return (
    <Fragment>
      <div className="crypto-tile flex justify-between items-center w-full">
        <div className="flex items-center justify-center gap-2">
          <img className="size-[40px] rounded-full" src={imageUrl} />
          <h2 className={`${isBitramp() ? "text-white" : "text-black"} font-[700]`}>
            {currency?.currency ?? "N/A"}
          </h2>
        </div>
        <p className={`${isBitramp() ? "text-white" : "text-black"} font-[400]`}>{currency?.count ?? "N/A"}</p>
      </div>
      <hr className={`${isBitramp() ? "border-[#464646]" : "border-[#D9D9D9]"} w-full border-[1px] opacity-20  my-1`} />
    </Fragment>
  );
};

export default CryptoTile;
